module.exports = __webpack_public_path__ + "img/about_1.fd85b3cb.png";